import React from 'react';

import Tooltip from "@material-ui/core/Tooltip";

import CheckBox from "@material-ui/icons/CheckBox";
import Wifi from "@material-ui/icons/Wifi";
import RoomService from "@material-ui/icons/RoomService";
import LocalLaundryService from "@material-ui/icons/LocalLaundryService";
import Kitchen from "@material-ui/icons/Kitchen";
import DriveEta from "@material-ui/icons/DriveEta";
import PersonPin from "@material-ui/icons/PersonPin";
import FreeBreakfast from "@material-ui/icons/FreeBreakfast";
import RestaurantMenu from "@material-ui/icons/RestaurantMenu";
import Fastfood from "@material-ui/icons/Fastfood";
import Tv from "@material-ui/icons/Tv";
import Pool from "@material-ui/icons/Pool";
import HotTub from "@material-ui/icons/HotTub";
import AirlineSeatFlat from "@material-ui/icons/AirlineSeatFlat";
import SwapHoriz from "@material-ui/icons/SwapHoriz";
import Whatshot from "@material-ui/icons/Whatshot";
import Terrain from "@material-ui/icons/Terrain";
import Toll from "@material-ui/icons/Toll";
import ChildCare from "@material-ui/icons/ChildCare";
import LocalBar from "@material-ui/icons/LocalBar";
import DirectionsBike from "@material-ui/icons/DirectionsBike";
import LocalCafe from "@material-ui/icons/LocalCafe";
import AirportShuttle from "@material-ui/icons/AirportShuttle";

export default ({serv, tooltipClasses}) => {
    switch (serv) {
        case 'WiFi':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Wifi style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Servicio a la habitación':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <RoomService style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Lavandería':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <LocalLaundryService style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Parqueadero':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <DriveEta style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Cocina y menaje':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Kitchen style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Empleada doméstica':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <PersonPin style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Desayuno':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <FreeBreakfast style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Almuerzo':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <RestaurantMenu style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Cena':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Fastfood style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Refrigerio':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Fastfood style={styles.vecIcons} />
                </Tooltip>
            );
        case 'TV':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Tv style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Piscina':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Pool style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Sauna':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <HotTub style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Masajes':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <AirlineSeatFlat style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Hamacas':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <SwapHoriz style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Zona de BBQ':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Whatshot style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Camping':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Terrain style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Agua caliente':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <HotTub style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Paintball':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <Toll style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Zona para niños':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <ChildCare style={styles.vecIcons} />
                </Tooltip>
            );
        case 'MiniBar':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <LocalBar style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Alquiler de bicicletas':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <DirectionsBike style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Cafetería':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <LocalCafe style={styles.vecIcons} />
                </Tooltip>
            );
        case 'Transporte al alojamiento':
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <AirportShuttle style={styles.vecIcons} />
                </Tooltip>
            );
        default:
            return (
                <Tooltip title={serv} placement="bottom" classes={{ tooltip: tooltipClasses }}>
                    <CheckBox style={styles.vecIcons} />
                </Tooltip>
            );
    }
};

const styles = {
    vecIcons: {
        margin: "3px",
        color: "#757474"
    }
};


// WEBPACK FOOTER //
// ./src/components/common/IconsServices.js